import { makeStyles } from '@material-ui/core/styles';
import {
  convertLocalToISOInTimeZone,
  timeZone as formatTimeZone,
  updateDateWithTimeString,
} from '@onwardcare/core';

const useStyles = makeStyles(theme => ({
  timeZoneText: {
    fontSize: 'small',
    color: theme.palette.text.hint,
  },
}));

export default function TimeZoneTimeText({
  date,
  time,
  timeZone,
}: {
  date: Date;
  time: string;
  timeZone?: string;
}) {
  const classes = useStyles();
  const dateToUse = time === '' ? date : updateDateWithTimeString(date, time);
  // Because the date and time being passed in is in the user's local time, we
  // need to convert it to the timezone that's passed in before we display it.
  const dateInTimeZone = convertLocalToISOInTimeZone(dateToUse, timeZone);
  const formattedTimeZone = formatTimeZone(new Date(dateInTimeZone), {
    timeZone,
  });

  return (
    <div className={classes.timeZoneText}>Time is in {formattedTimeZone}</div>
  );
}
